import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaTalleres from './TablaTalleres';

const Talleres: React.FC = () => (
  <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
    <TablaTalleres />
  </Box>
);

export default Talleres;
